export { default as serverConstants } from "Shared/Generated/Constants.json";

// min/max date: https://stackoverflow.com/a/43794682/152711
export const MAX_DATE = new Date(8640000000000000);
export const MIN_DATE = new Date(-8640000000000000);
